export default __webpack_public_path__ + "static/media/Video_or_Audio.9116ba6a.svg";